import { render, staticRenderFns } from "./CopilotoRutas.vue?vue&type=template&id=6d4c4439&"
import script from "./CopilotoRutas.vue?vue&type=script&lang=ts&"
export * from "./CopilotoRutas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports